import { mdiImageAlbum } from '@mdi/js'

export default {
  title: 'Slider Super Admin',
  to: 'slider-superadmin-list',
  icon: mdiImageAlbum,
  resource: 'SliderAdmin',
  action: 'read',
}
